<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import { authComputed, userListMethod, siteListMethod } from '@state/helpers'

export default {
  page: {
    title: 'Update admin',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      adminError: null,
      isadminError: false,
      isLoading: false,
      show: false,
      adminId: null,
      adminSuccess: '',
      isSuccess: false,
      departmentlist: [],
      department: '',
      phone: '',
      adminRole: '',
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getDepartments()
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    getDepartments() {
      this.fetchDepartmentList()
        .then((department) => {
          var listitems = []
          department.forEach((element) => {
            var ele = {}
            ele = element.departmentName
            listitems.push(ele)
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
    // save admin method
    saveAdminDetails() {
      if (
        this.firstName === this.data.first_name &&
        this.lastName === this.data.last_name &&
        this.department === this.data.department &&
        this.adminRole === this.data.role &&
        this.phone === this.data.phone
      ) {
        this.adminError = 'No changes done in data.'
        this.isadminError = true
      } else {
        let Data = {
          id: this.data._id,
          first_name: this.firstName,
          last_name: this.lastName,
          department: this.department,
          role: this.adminRole,
        }
        if (this.phone.toString() !== this.data.phone.toString()) {
          Data.phone = this.phone
        }
        this.updateUser({ Data })
          .then((admin) => {
            this.isLoading = false
            this.isadminError = false
            this.adminSuccess = 'Details Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.adminError = getError.message
            this.isadminError = true
          })
      }
    },

    resetModal() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.phone = this.data.phone
      this.department = this.data.department
      this.adminError = ''
      this.isadminError = false
      this.adminSuccess = ''
      this.isSuccess = false
      this.adminRole = this.data.role
    },
    getData() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.department = this.data.department
      this.phone = this.data.phone
      this.adminRole = this.data.role
    },
  },
}
</script>

<template>
  <b-modal
    id="admin-update-modal"
    title="Update "
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isadminError"
          variant="danger"
          v-html="adminError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="adminSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveAdminDetails">
          <b-form-group label="First Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="firstName"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Last Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="lastName"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Email" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="data.email"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Role" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="adminRole"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Phone" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="phone"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
